module.exports = __webpack_public_path__ + "static/media/Hitmontop_gaussian2.9d757419.png";